(function () {
    'use strict';

    angular.module("imApp").factory("custFactsService", ['$ihttp', function ($ihttp) {
        let service = {
            getCustomerFacts: function (parms) {
                return $ihttp.post({
                    method: 2912,
                    parameters: parms || {}
                });
            },
            listCustomerFacts: function (parms) {
                return $ihttp.post({
                    method: 2913,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2914,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
